import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { useMeta } from "components/Footer/Footer.hooks";

export const Bootstrap = () => {
  const { isError, error } = useMeta();
  let message = isError ? (
    error?.message === 'Quota exceeded.'
      ? <>접속량 증가로 서비스가 원활하지 않습니다. 잠시 후 다시 시도해 주세요.<br />복구 예정 시각: 17시</>
      : <>에러가 발생했습니다. {error?.message}</>
  ) : null;
  return isError ? (
    <Container>
      <Row>
        <Col>
          <div className="alert alert-danger">{message}</div>
        </Col>
      </Row>
    </Container>
  ) : null;
}
